import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_CLASS_ENROLLMENTS_STATE = "class-enrollments";

export const classEnrollmentsCrudConfig: CrudConfig = Object.freeze({
  name: "enrollments",
  path: "seneca/enrollments/classes/meta",
  idFieldName: "classId",
  callTypes: [
    AllowedCallTypes.FETCH_ALL,
    AllowedCallTypes.FETCH,
    AllowedCallTypes.CREATE,
    AllowedCallTypes.DELETE
  ]
});

export const childClassEnrollmentsCrudConfig: CrudConfig = Object.freeze({
  name: "child-class-enrollments",
  path: "seneca/enrollments/classes/meta",
  idFieldName: "userId",
  callTypes: [AllowedCallTypes.FETCH]
});
